export default __webpack_public_path__ + "static/media/Boots of Crimson Slaughter (nm).508f0d58.jpg";